var _rect, _circle, _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSubmitImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 63,
    viewBox: "0 0 49 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48.3617,
    height: 61.903,
    rx: 6,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 49 0.576172)",
    fill: "#F4F4FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 6.28703,
    transform: "matrix(-1 -8.74228e-08 -8.74228e-08 1 30.1392 20.4037)",
    fill: "url(#paint0_linear_725_534)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.3321 40.0545L20.8896 59.1735C19.7745 60.4702 20.6957 62.4776 22.406 62.4776L42.9996 62.4776C46.3133 62.4776 48.9996 59.7913 48.9996 56.4776L48.9996 50.0316L40.3607 40.0498C39.5615 39.1263 38.1284 39.1285 37.3321 40.0545Z",
    fill: "url(#paint1_linear_725_534)",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1216 31.2745L44.7234 59.293C45.6946 60.6138 44.7515 62.4778 43.1121 62.4778L0.637902 62.4778L0.637904 47.4856L21.2568 30.9009C22.144 30.1873 23.4471 30.3572 24.1216 31.2745Z",
    fill: "url(#paint2_linear_725_534)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_725_534",
    x1: 6.54899,
    y1: 12.0193,
    x2: 7.07016,
    y2: 3.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8588F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_725_534",
    x1: 34.1687,
    y1: 61.4109,
    x2: 34.9528,
    y2: 44.7042,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8588F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_725_534",
    x1: 22.8843,
    y1: 61.0269,
    x2: 21.9171,
    y2: 38.2969,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#585CEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8588F3"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubmitImageIcon);
export default __webpack_public_path__ + "static/media/SubmitImageIcon.67583f1e58a96ded675ac7fb8cee0f9f.svg";
export { ForwardRef as ReactComponent };